function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/require-default-props */
import React from 'react';
import { string, node, bool } from 'prop-types';
import cn from 'classnames';
import LabelWrapper from './styles/LabelWrapper';
import LabelBase from './styles/LabelBase';
import LabelText from './styles/LabelText';

function Label(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      children = _ref.children,
      label = _ref.label,
      labelFor = _ref.labelFor,
      _ref$expand = _ref.expand,
      expand = _ref$expand === void 0 ? true : _ref$expand,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      setWidth = _ref.setWidth,
      color = _ref.color,
      _ref$dataAnalyticsId = _ref.dataAnalyticsId,
      dataAnalyticsId = _ref$dataAnalyticsId === void 0 ? undefined : _ref$dataAnalyticsId,
      _ref$dataAnalyticsLab = _ref.dataAnalyticsLabel,
      dataAnalyticsLabel = _ref$dataAnalyticsLab === void 0 ? undefined : _ref$dataAnalyticsLab,
      restProps = _objectWithoutProperties(_ref, ["className", "children", "label", "labelFor", "expand", "required", "setWidth", "color", "dataAnalyticsId", "dataAnalyticsLabel"]);

  // if we have a default style to pass in
  var requiredColor = '#ba4534';
  return /*#__PURE__*/React.createElement(LabelWrapper, {
    className: "wrapper-label",
    style: {
      width: expand === false && setWidth
    }
  }, /*#__PURE__*/React.createElement(LabelBase, _extends({
    className: cn('scl-label', className),
    htmlFor: labelFor,
    "data-analytics-id": dataAnalyticsId,
    "data-analytics-label": dataAnalyticsLabel,
    "data-test-id": "label",
    style: {
      color: color
    }
  }, restProps), /*#__PURE__*/React.createElement(LabelText, {
    className: "label-text"
  }, label, required === true && /*#__PURE__*/React.createElement("span", {
    className: "required",
    style: {
      display: 'inline-flex',
      color: requiredColor,
      marginLeft: '0.313rem'
    }
  }, "*")), children));
}

Label.propTypes = {
  /**
   * Define additional classNames.
   */
  className: string,

  /**
   * Define label's text.
   */
  children: node,

  /**
   * Define data analytics label.
   */
  dataAnalyticsLabel: string,

  /**
   * Define data analytics id.
   */
  dataAnalyticsId: string,

  /**
   * Define label's copy.
   */
  label: string,

  /**
   * Define label's for attribute.
   */
  labelFor: string,

  /**
   * Define if input width is 100%.
   */
  expand: bool,

  /**
   * Set a input width (expand must be set to false).
   */
  setWidth: string,

  /**
   * Define a font color
   */
  color: string,

  /**
   * Define if the input is required
   */
  required: bool
};
export default Label;